var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { useDarkMode } from "@macrostrat/ui-components";

function LineIcon(props) {
  var darkMode = useDarkMode();
  var color = darkMode.isEnabled ? "#cccccc" : "#666666";

  var _props$size = props.size,
      size = _props$size === void 0 ? 50 : _props$size,
      rest = _objectWithoutProperties(props, _excluded);

  var style = _objectSpread({
    fill: color,
    stroke: color,
    strokeWidth: "4px"
  }, props); // let scale = `scale(${this.props.size / 500})`


  var scale = "scale(1)";
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 107",
    height: size,
    width: size,
    className: "custom-svg-icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: scale
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "7.74 6.47 64.78 52.73 123.34 100.22",
    style: style
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35.62 30.02 43.58 36.47 34.29 39.79 35.62 30.02",
    style: style
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "88.05 71.86 96 78.31 86.72 81.64 88.05 71.86",
    style: style
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.43 50.76 69.39 57.21 60.1 60.53 61.43 50.76",
    style: style
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.02 92.11 120.97 98.56 111.69 101.89 113.02 92.11",
    style: style
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9.07 7.62 17.02 14.06 7.74 17.39 9.07 7.62",
    style: style
  })));
}

export default LineIcon;